const ITEMS = [
  "Café da Manhã",
  "Caixas Presente",
  "Balões",
  "Mimos",
  "Formatura",
  "Maternidade",
  "Infantis",
  "Momentos Especiais",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-espresso text-cream py-5 overflow-hidden border-y border-espresso" data-testid="marquee-section">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display italic text-xl sm:text-2xl px-6">{item}</span>
                <span className="text-brand text-lg">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
